// @flow

import _ from 'lodash';

import type {
  CustomRangeSliderState,
  CustomRangeSliderAction
} from 'stores/flow-type/custom-range-slider.type';

import {
  GET_CUSTOM_RANGE_SLIDERS_REQUEST,
  GET_CUSTOM_RANGE_SLIDERS_SUCCESS,
  GET_CUSTOM_RANGE_SLIDERS_FAILURE,
  UPDATE_CUSTOM_RANGE_SLIDER_REQUEST,
  UPDATE_CUSTOM_RANGE_SLIDER_SUCCESS,
  UPDATE_CUSTOM_RANGE_SLIDER_FAILURE,
  DELETE_CUSTOM_RANGE_SLIDER_REQUEST,
  DELETE_CUSTOM_RANGE_SLIDER_SUCCESS,
  DELETE_CUSTOM_RANGE_SLIDER_FAILURE,
  CREATE_CUSTOM_RANGE_SLIDER_REQUEST,
  CREATE_CUSTOM_RANGE_SLIDER_SUCCESS,
  CREATE_CUSTOM_RANGE_SLIDER_FAILURE
} from 'stores/flow-type/custom-range-slider.type';

const initialState: CustomRangeSliderState = {
  loading: false,
  saving: false,
  deleting: false,
  reordering: false,
  scheduleSyncIn: 0,
  scheduleSyncAfter: 0,
  waitSyncAt: 0,

  success: false,
  error: null,
  customRangeSliders: [],
  total: 0
};

const customRangeSliderReducers = (
  state: FilterDataState = initialState,
  action: CustomRangeSliderAction
) => {
  switch (action.type) {
    // Get custom range sliderss
    case GET_CUSTOM_RANGE_SLIDERS_REQUEST:
      return {
        ...state,
        success: false,
        loading: true,
        waitSyncAt: 0,
        scheduleSyncIn: 0,
        scheduleSyncAfter: 0
      };
    case GET_CUSTOM_RANGE_SLIDERS_SUCCESS: {
      const { data } = action.payload;
      let { data: customRangeSliders, total, waitSyncAt, scheduleSyncIn, scheduleSyncAfter } = data;

      return {
        ...state,
        loading: false,
        success: true,
        error: undefined,
        customRangeSliders,
        total,
        waitSyncAt,
        scheduleSyncIn,
        scheduleSyncAfter
      };
    }
    case GET_CUSTOM_RANGE_SLIDERS_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };

    // Update custom range sliders rule
    case UPDATE_CUSTOM_RANGE_SLIDER_REQUEST:
      return {
        ...state,
        success: false,
        saving: true,
        waitSyncAt: 0,
        scheduleSyncIn: 0,
        scheduleSyncAfter: 0
      };
    case UPDATE_CUSTOM_RANGE_SLIDER_SUCCESS: {
      let {
        data: customRangeSlider,
        total,
        waitSyncAt,
        scheduleSyncIn,
        scheduleSyncAfter
      } = action.payload.data;

      // Update
      const { id } = customRangeSlider;
      let customRangeSliders = [...state.customRangeSliders];
      const index = _.findIndex(customRangeSliders, item => item.id === id);
      customRangeSliders[index] = customRangeSlider;

      // Save updated custom range sliders to store
      return {
        ...state,
        saving: false,
        success: true,
        customRangeSliders,
        total,
        scheduleSyncIn,
        scheduleSyncAfter,
        waitSyncAt,
        error: undefined
      };
    }
    case UPDATE_CUSTOM_RANGE_SLIDER_FAILURE:
      return {
        ...state,
        saving: false,
        success: false,
        error: action.payload
      };

    // Delete custom range sliders rule
    case DELETE_CUSTOM_RANGE_SLIDER_REQUEST:
      return {
        ...state,
        success: false,
        deleting: true,
        waitSyncAt: 0,
        scheduleSyncIn: 0,
        scheduleSyncAfter: 0
      };
    case DELETE_CUSTOM_RANGE_SLIDER_SUCCESS: {
      const {
        data: customRangeSliders,
        total,
        scheduleSyncIn,
        scheduleSyncAfter,
        waitSyncAt
      } = action.payload.data;
      return {
        ...state,
        deleting: false,
        success: true,
        customRangeSliders,
        total,
        scheduleSyncIn,
        scheduleSyncAfter,
        waitSyncAt,
        error: undefined
      };
    }
    case DELETE_CUSTOM_RANGE_SLIDER_FAILURE:
      return {
        ...state,
        deleting: false,
        success: false,
        error: action.payload
      };

    // Create custom range sliders
    case CREATE_CUSTOM_RANGE_SLIDER_REQUEST:
      return {
        ...state,
        success: false,
        saving: true,
        waitSyncAt: 0,
        scheduleSyncIn: 0,
        scheduleSyncAfter: 0
      };
    case CREATE_CUSTOM_RANGE_SLIDER_SUCCESS: {
      let {
        data: customRangeSlider,
        total,
        waitSyncAt,
        scheduleSyncIn,
        scheduleSyncAfter
      } = action.payload.data;
      let customRangeSliders = [...state.customRangeSliders];
      customRangeSliders.push(customRangeSlider);

      return {
        ...state,
        saving: false,
        customRangeSliders,
        total,
        success: true,
        scheduleSyncIn,
        scheduleSyncAfter,
        waitSyncAt,
        error: undefined
      };
    }
    case CREATE_CUSTOM_RANGE_SLIDER_FAILURE:
      return {
        ...state,
        saving: false,
        success: false,
        error: action.payload
      };

    default:
      return state;
  }
};
export default customRangeSliderReducers;
